import { render, staticRenderFns } from "./order.vue?vue&type=template&id=9fe098ae&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=9fe098ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe098ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe098ae')) {
      api.createRecord('9fe098ae', component.options)
    } else {
      api.reload('9fe098ae', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=9fe098ae&scoped=true&", function () {
      api.rerender('9fe098ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/specialty/order.vue"
export default component.exports